import React, { useState, useEffect } from 'react';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const ErrorAlertModal = ({isOpen, error}) => {
   const [isModalOpen, setIsModalOpen] = useState(false);

   useEffect(() => {
      if (isOpen) {
         setIsModalOpen(true);
      }
   }, [isOpen]);

   const closeModal = () => {
      setIsModalOpen(false);
   };

   return (
      <Modal
         isOpen={isModalOpen}
         toggle={closeModal}
      >
         <ModalHeader toggle={closeModal}>
            Error
         </ModalHeader>
         <ModalBody>
            {`Error Message: ${ error }`}
         </ModalBody>
         <ModalFooter>
            <Button
               className='loading-button btn-dark-orange btn-rounded px-4 btn btn-secondary'
               type='submit'
               onClick={closeModal}
            >
               Ok
            </Button>
         </ModalFooter>
      </Modal>
   );
};

export default ErrorAlertModal;
